
<template>
  <v-app light>
    <v-content :style="'background: #673A33 url(\'/img/background.' + ($webp ? 'webp' : 'png') + '\') repeat-x bottom;'">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <p class="text-xs-center my-4">
              <vue-responsive-image :image-url="'/img/logo.png'" :width-on-screen="30" :width-on-screen-tablet="50" :width-on-screen-smartphone="90" :image-ratio="16/9" :alt="'CustoBov'" :image-class="'vw50'" :mode="'all'"></vue-responsive-image>
            </p>
          </v-flex>
          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-title primary-title>
                <div class="headline">Bem-Vind@!</div>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="showDetails">
                  <v-icon color="teal darken-3">info</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p>
                  Este aplicativo permite simular o desempenho econômico e ambiental de sistemas de produção de bovinos de corte.
                </p>
                <p>
                  Você deve efetuar <strong>login</strong> para poder sincronizar suas simulações com a
                  <a href="https://embrapa.br" style="color:#00695c;" target="_blank" rel="noopener">Embrapa</a>, de forma a
                  <strong>recuperá-las em caso de perda ou troca do dispositivo</strong> (computador, celular, tablet, etc).
                </p>
                <p>
                  Além disso, seus dados poderão ser utilizados, sempre de forma anônima, em futuras pesquisas científicas para
                  criação de tecnologias inovadoras para a agropecuária.
                </p>
              </v-card-text>

              <v-btn @click.stop="showPrivacy" large color="purple" class="white--text" block>
                <v-icon dark left>gavel</v-icon>
                Política de Privacidade
              </v-btn>

              <v-switch color="purple" label="Li e aceito os termos." v-model="agree" class="mt-3"></v-switch>

              <v-alert type="error" icon="warning" :value="error" transition="scale-transition" class="mx-1">
                {{ error }}
              </v-alert>
              <v-layout align-center justify-center row wrap v-if="agree">
                <v-flex xs12 sm12 md6 lg6 xl6 v-for="provider in providers" :key="provider.name" class="px-1" style="text-align: center;">
                  <v-btn large :color="provider.color" @click="authenticate(provider.name)" class="white--text" block>
                    <v-icon dark left v-html="provider.icon"></v-icon>
                    {{ provider.label }}
                  </v-btn>
                </v-flex>
                <!-- <v-flex xs12 sm12 md6 lg6 xl6 class="px-1 my-1" style="text-align: center;">
                  <g-signin-button :params="googleSignInParams" @success="onSignInSuccessGoogle" @error="onSignInErrorGoogle" block>
                    <v-icon dark left class="mx-2 my-0">fab fa-google</v-icon>
                    Google
                  </g-signin-button>
                </v-flex> -->
                <!-- <v-flex xs12 sm12 md6 lg6 xl6 class="px-1 my-1" style="text-align: center;">
                  <fb-signin-button :params="facebookSignInParams" @success="onSignInSuccessFacebook" @error="onSignInErrorFacebook" block>
                    <v-icon dark left class="mx-2 my-0">fab fa-facebook</v-icon>
                    Facebook
                  </fb-signin-button>
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <p class="text-xs-center my-4 hidden-sm-and-up">
              <img src="/img/partners-white-landscape.png" style="width: 250px;" alt="Logo da Embrapa e CNA" />
            </p>

            <p class="text-xs-center my-4 hidden-xs-only">
              <img src="/img/partners-white-landscape.png" style="width: 400px;" alt="Logo da Embrapa e CNA" />
            </p>
          </v-flex>
        </v-layout>
      </v-container>

    </v-content>

    <v-dialog v-model="wait" persistent max-width="300px">
      <v-card>
        <v-card-text style="text-align: center;">
          <v-progress-circular indeterminate :size="70" :width="7" color="purple lighten-2"></v-progress-circular>
        </v-card-text>
        <v-card-title class="headline" block style="text-align: center;">Autenticando... por favor, aguarde!</v-card-title>
      </v-card>
    </v-dialog>

    <text-dialog @consent="agree = true" @dissent="agree = false" ref="dPrivacy"></text-dialog>
    <text-dialog ref="dDetails"></text-dialog>

    <v-snackbar :timeout="30000" color="info" :multi-line="true" :vertical="false" v-model="ios" :auto-height="true">
      <v-btn dark @click.native="installIOS()" class="px-3" color="orange">
        <v-icon left dark>get_app</v-icon>
        Instalar
      </v-btn>
      <v-btn dark flat @click.native="ios = false">Fechar</v-btn>
    </v-snackbar>

    <v-dialog v-model="install" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="info">
          <v-toolbar-title>Instalar no Dispositivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="install = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-img src="/img/ios.png" contain alt="Adicionando à tela inicial no iOS" class="mt-3" />
      </v-card>
    </v-dialog>
  </v-app>

</template>

<script>
/* eslint-disable */ 
import axios from 'axios'
import VueResponsiveImage from 'vue-responsive-image'
import TextDialog from '../components/Dialog.vue'

var settings = require('../settings/' + process.env.NODE_ENV + '.json')

require('../library/facebook.js')

export default {
  components: {
    TextDialog,
    VueResponsiveImage
  },
  data () {
    return {
      facebookSignInParams: {
        scope: 'email,public_profile',
        return_scopes: true
      },
      googleSignInParams: {
        client_id: settings.auth.google
      },
      privacy: '',
      details: '',
      agree: false,
      wait: false,
      error: false,
      settings: settings,
      ios: false,
      install: false,
      all: [
        { name: 'google', label: 'Google', icon: 'fab fa-google', color: 'red darken-3' },
        { name: 'facebook', label: 'facebook', icon: 'fab fa-facebook', color: 'indigo darken-4' },
        { name: 'twitter', label: 'twitter', icon: 'fab fa-twitter', color: 'light-blue' },
        { name: 'instagram', label: 'instagram', icon: 'fab fa-instagram', color: 'pink' },
        { name: 'linkedin', label: 'linkedin', icon: 'fab fa-linkedin', color: 'blue-grey' },
        { name: 'microsoft', label: 'microsoft', icon: 'fab fa-microsoft', color: 'blue' }
      ]
    }
  },
  computed: {
    providers: function () {
      return this.all.filter(function (e) {
        if (String(settings.auth[e.name]).trim().length > 0) {
          return e
        }
      })
    }
  },
  beforeCreate () {
    if (this.$localStorage.user.authenticated) {
      this.$router.push({ path: '/home' })
    }
  },
  mounted () {
    this.loadFiles()

    // console.log(JSON.stringify(this.mobile))
  },
  methods: {
    installIOS () {
      this.ios = false

      this.install = true

      this.$localStorage.set('iosTryInstall', false)
    },
    onSignInSuccessFacebook (facebook) {
      console.log('#1 - Success to sign in Facebook!')

      console.log(JSON.stringify(facebook))

      this.wait = true

      this.authenticate('facebook')
    },
    onSignInErrorFacebook (error) {
      console.log(error)

      this.error = 'Ops! Ocorreu um erro ao tentar autenticá-lo(a)! Por favor, tente novamente mais tarde.'

      this.wait = false

      throw new Error(error)
    },
    onSignInSuccessGoogle (google) {
      console.log('#1 - Success to sign in Google!')

      console.log(JSON.stringify(google))

      this.wait = true

      this.authenticate('google')
    },
    onSignInErrorGoogle (error) {
      console.log(error)

      this.error = 'Ops! Ocorreu um erro ao tentar autenticá-lo(a)! Por favor, tente novamente mais tarde.'

      this.wait = false

      throw new Error(error)
    },
    authenticate (provider) {
      this.error = false
      this.wait = true

      var self = this

      console.log('Provider: ' + provider)
      console.log('#1 - Start autenticate...')
      this.$auth.authenticate(provider).then(function (response) {
        console.log('#2 - Access Token: ' + response.data.token)

        var token = response.data.token

        console.log('#3 - Trying to connect in remote server...')
        axios.get(settings.api + '/user', { headers: { Authorization: 'Bearer ' + token } }).then((response) => {
          console.log(JSON.stringify(response.data))

          self.$localStorage.set('user', {
            authenticated: true,
            name: response.data.name,
            email: response.data.email,
            picture: response.data.picture,
            token: token
          })

          self.$root.$data.trySync = true

          self.wait = false
          console.log('#4 - Done...')
          self.$router.push({ path: '/home' })
        }).catch(function (error) {
          self.wait = false
          self.error = true

          console.log(JSON.stringify(error))
        })
      }).catch(error => {
        console.log(error)

        self.$err(error)

        self.wait = false

        self.error = 'Atenção! O servidor remoto parece estar indisponível. Por favor, verifique sua conexão com a internet ou tente novamente mais tarde.'
      })
    },
    loadFiles () {
      var p = '../privacy-policy.html'
      var d = '../details.html'

      var self = this

      axios.get(p).then(
        function (r) {
          self.privacy = r.data
        })

      axios.get(d).then(
        function (r) {
          self.details = r.data
        })
    },
    showPrivacy () {
      this.$refs.dPrivacy.open('Política de Privacidade', this.privacy, 'Aceito', 'Não Aceito')
    },
    showDetails () {
      this.$refs.dDetails.open('Mais Informações', this.details, 'Fechar')
    }
  }
}
</script>
<style>
.g-signin-button,
.fb-signin-button {
  display: inline-block;
  width: 100%;
  padding: 0px;
  border-radius: 3px;
  cursor: pointer;
}
.g-signin-button i,
.fb-signin-button i {
  height: 48px;
  line-height: 42px;
  vertical-align: middle;
}
.g-signin-button {
  background-color: #C62828;
  color: #fff;
}
.fb-signin-button {
  background-color: #4267b2;
  color: #fff;
}
</style>
